export default __webpack_public_path__ + "static/media/app-bar-logo.bbc4beed.svg";